// extracted by mini-css-extract-plugin
module.exports = {"container":"PanGrid_container__35EGe","segment":"PanGrid_segment__2Pssy","segment_right":"PanGrid_segment_right__sUlbW PanGrid_segment__2Pssy"};